import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const MenuItem = ({ activeItem, text, anchor }) => (
  <Link
    to={`/${anchor}`}
    className={activeItem === anchor ? 'header__menu__active' : ''}
  >
    {text}
  </Link>
);

MenuItem.propTypes = {
  activeItem: PropTypes.string,
  text: PropTypes.string.isRequired,
  anchor: PropTypes.string,
};

export default MenuItem;



// WEBPACK FOOTER //
// ./src/components/ui/Header/MenuItem/index.js